/**
 * Determines the test schedule status based on the next test overdue date.
 *
 * @param nextTestOverdueDate - The ISO date string representing when the test becomes overdue
 * @returns 'due' if the overdue date hasn't passed yet, 'overdue' if it has passed, or '-' if no date is provided
 */

type TestScheduleStatusReturnType = 'due' | 'overdue' | '-';

export const getTestScheduleStatus = (
  nextTestOverdueDate?: string | null
): TestScheduleStatusReturnType => {
  if (!nextTestOverdueDate) {
    return '-';
  }

  const overdueDate = new Date(nextTestOverdueDate);
  const now = new Date();

  return overdueDate >= now ? 'due' : 'overdue';
};
